import { WIX_ECOM } from '@wix/app-definition-ids';

export const ECOM_APP_DEF_ID = WIX_ECOM;

export const WishlistStatus = {
  Added: 'added',
  Removed: 'removed',
};
